import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';

export class CopyToClipboardService {
    constructor(private growl: Growl) {}

    // https://randomlol.de/2015/08/17/angular-copy-to-clipboard/
    public copyTextToClipboard(text: string): void {
        let textAreaElement = document.createElement('textarea');

        // Place in outside of the visible area of the screen regardless of scroll position.
        textAreaElement.style.position = 'absolute';
        textAreaElement.style.top = '-100';
        textAreaElement.style.left = '0';

        // add text to the textbox
        textAreaElement.value = text;

        // append textAreaElement to document
        document.body.appendChild(textAreaElement);

        // select the content
        textAreaElement.select();

        try {
            let successful = document.execCommand('copy');
            let msg = successful ? 'successful' : 'unsuccessful';
        } catch (err) {
            this.growl.show(
                'Something went wrong when copying the token. Please try to copy the token manually.',
                'danger'
            );
        }

        // remove the textAreaElement from the document
        document.body.removeChild(textAreaElement);

        // unload
        textAreaElement = undefined;
    }
}

angular.module('app').service('copyToClipboardService', CopyToClipboardService);
